import { Content } from '@raydiant/api-client-js';
import cn from 'classnames';
import { getPresentationData } from '../LibraryPage/utils';
import SidebarMenuTooltip from '../../components/Sidebar/SidebarMenuTooltip';
import { capitalize } from '../../utilities/stringUtils';
import { User } from '@raydiant/raydial/components/Icons';
import { Check } from './AddContentActionBarV2';
import ApplicationIcon from '../LibraryPage/v2/components/ApplicationIcon';
import Text from '@raydiant/raydial/components/Text';

interface AddContentPageContentCardProps {
  content: Content;
  showOwner?: boolean;
  selected?: boolean;
  onClick: (content: Content) => void;
  showButtonGroup?: boolean;
  batchMode?: boolean;
}

const AddContentPageContentCard = ({
  content,
  showOwner = false,
  selected = false,
  onClick,
  batchMode = false,
}: AddContentPageContentCardProps) => {
  const nextContent = {
    ...content,
    presentationData: getPresentationData(content),
  };

  const renderShowOwnerInfo = () => {
    return (
      <SidebarMenuTooltip
        placement="bottom"
        title={`Owner: ${capitalize(content.ownedBy.name)}`}
        arrow
      >
        <div
          className="bg-white w-6 h-6 rounded-xl flex items-center justify-center text-gray-600"
          onClick={(e) => e.stopPropagation()}
        >
          <User size={15} className="mb-0.5" />
        </div>
      </SidebarMenuTooltip>
    );
  };

  const renderSelectStatus = (content: Content) => {
    return (
      <div
        className="bg-white w-6 h-6 rounded-xl flex items-center justify-center"
        onClick={(e) => {
          e.stopPropagation();
          onClick(content);
        }}
      >
        {selected && <Check className="fill-blue-600" />}
      </div>
    );
  };

  return (
    <div
      className={cn(
        'h-[185px] rounded-[20px] shadow border-2 border-grey-100 flex-col justify-start items-start inline-flex cursor-pointer',
        selected && 'border-blue-600',
      )}
      onClick={() => onClick(content)}
    >
      <div
        className="w-[216px] h-[125px] p-4 rounded-t-[17px] justify-between flex bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url(${
            nextContent.presentationData.thumbnailUrl ||
            content.presentationData.applicationThumbnailUrl
          })`,
        }}
      >
        <div>{batchMode && renderSelectStatus(content)}</div>
        <div>{showOwner && renderShowOwnerInfo()}</div>
      </div>
      <div className="w-[216px] h-[60px] px-4 bg-white rounded-b-[20px] flex-col justify-center items-start gap-2.5 flex">
        <div className="self-stretch justify-start items-center gap-2 inline-flex">
          <ApplicationIcon
            url={nextContent.presentationData.applicationIconUrl}
          />
          <div className="grow shrink basis-0 text-gray-600 break-all line-clamp-2">
            <Text variant="body">{nextContent.name}</Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddContentPageContentCard;
